export const createKnmEventInspectorSelectOption = (knmEventInspectorName: string, guid: string) => ({
  label: knmEventInspectorName,
  value: knmEventInspectorName,
  id: guid,
});
